module.exports = __webpack_public_path__ + "static/richard-osman-47d5cf4fd6600dfa796f03d07d3d9b73.jpg";